import React from 'react';
import { Accordion, Grid } from 'semantic-ui-react';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import RequestName from '../containers/RequestName';
import RequestStatus from '../containers/RequestStatus';
import RequestSummaryList from './RequestSummaryList';
import RequestFieldList from '../forms/components/RequestFieldList';
import RequestOutcomeList from './RequestOutcomeList';
import { approvalStatus, approvedOrDenied } from '../constants';
import RequestUnknownFields from '../forms/components/RequestUnknownFields';
import RequestDestinationAccordion from './RequestDestinationAccordion';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestInfoGrid = ({ category, code }) => {
  const state = Selectors.useRequestPanelContent({ category, code });
  const updatePanels = Events.useUpdateRequestPanels(category, { code });

  return (
    <Grid>
      <Grid.Row columns="equal">
        <Grid.Column>
          <RequestName code={code} category={category} />
        </Grid.Column>
        <Grid.Column textAlign="right">
          <RequestStatus code={code} category={category} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns="equal">
        <Grid.Column>
          <Accordion styled>
            {Object.values(approvedOrDenied).includes(state.status) && (
              <SimpleAccordion
                active={state.panels.left.includes(0)}
                headerId={state.status === approvalStatus.APPROVE ? 'request.approval.title' : 'request.denied.title'}
                index={0}
                onClick={() => updatePanels({ index: 0, panel: 'left' })}
              >
                <RequestOutcomeList code={code} category={category} />
              </SimpleAccordion>
            )}
            <SimpleAccordion
              active={state.panels.left.includes(1)}
              headerId="request.summary.title"
              index={1}
              onClick={() => updatePanels({ index: 1, panel: 'left' })}
            >
              <RequestSummaryList code={code} category={category} withLinks />
            </SimpleAccordion>
            <RequestDestinationAccordion
              active={state.panels.left.includes(2)}
              category={category}
              code={code}
              index={2}
              onClick={() => updatePanels({ index: 2, panel: 'left' })}
            />
          </Accordion>
        </Grid.Column>
        <Grid.Column>
          <Accordion styled>
            <SimpleAccordion
              active={state.panels.middle.includes(0)}
              headerText={state.sections.project.label}
              index={0}
              onClick={() => updatePanels({ index: 0, panel: 'middle' })}
            >
              <RequestFieldList code={code} category={category} section="project" />
            </SimpleAccordion>
          </Accordion>
        </Grid.Column>
        <Grid.Column>
          <Accordion styled>
            <SimpleAccordion
              active={state.panels.right.includes(0)}
              headerText={state.sections.about.label}
              index={0}
              onClick={() => updatePanels({ index: 0, panel: 'right' })}
            >
              <RequestFieldList code={code} category={category} section="about" />
            </SimpleAccordion>
            <RequestUnknownFields
              code={code}
              category={category}
              index={1}
              active={state.panels.right.includes(1)}
              onClick={() => updatePanels({ index: 1, panel: 'right' })}
            />
          </Accordion>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default RequestInfoGrid;
